import { render, staticRenderFns } from "./modal-order-feedback-dashboard.vue?vue&type=template&id=5c875fc8"
import script from "./modal-order-feedback-dashboard.vue?vue&type=script&lang=js"
export * from "./modal-order-feedback-dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports